<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { BULLET_STYLES, showBulletWarning, showMigrate, styleEnabled, type BulletSettings, type BulletStyle } from '@/settings/listBullets'

// The list bullet settings: convert every bullet, or only `•` (hidden while converting everything), and the bullet to write.
defineProps<{ settings: BulletSettings; disabled?: boolean }>()
const emit = defineEmits<{ change: [changes: Partial<BulletSettings>] }>()

const { t } = useI18n()
</script>

<template>
  <div class="bullets">
    <label class="check">
      <input
        type="checkbox"
        :checked="settings.convert_list_bullets"
        :disabled="disabled"
        @change="emit('change', { convert_list_bullets: ($event.target as HTMLInputElement).checked })"
      />
      <span>{{ t('settings.listBullets.convert') }}</span>
    </label>
    <p class="hint">{{ t('settings.listBullets.convertHint') }}</p>
    <template v-if="showMigrate(settings)">
      <label class="check">
        <input
          type="checkbox"
          :checked="settings.migrate_bullet_lists"
          :disabled="disabled"
          @change="emit('change', { migrate_bullet_lists: ($event.target as HTMLInputElement).checked })"
        />
        <span>{{ t('settings.listBullets.migrate') }}</span>
      </label>
      <p class="hint">{{ t('settings.listBullets.migrateHint') }}</p>
    </template>
    <label>
      {{ t('settings.listBullets.style') }}
      <select
        :value="settings.list_bullet_style"
        :disabled="disabled || !styleEnabled(settings)"
        @change="emit('change', { list_bullet_style: ($event.target as HTMLSelectElement).value as BulletStyle })"
      >
        <option v-for="style in BULLET_STYLES" :key="style" :value="style">{{ style }}</option>
      </select>
    </label>
    <p v-if="showBulletWarning(settings)" class="hint warning" role="note">{{ t('settings.listBullets.warning') }}</p>
  </div>
</template>

<style scoped>
.check {
  display: flex;
  align-items: center;
  gap: 8px;
}
.bullets {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
</style>
